import { PagedSearch } from 'src/app/shared';

export class DashboardReportSearchDto extends PagedSearch {
  UserNum: number;
}
